var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1318 13.5813L17.3576 10.3555L6.93832 4.49949C6.24777 4.12639 5.60086 4.07403 5.03359 4.48203L14.1318 13.5813ZM17.9074 17.358L21.2609 15.4718C21.9154 15.1053 22.2743 14.586 22.2743 14.01C22.2743 13.4351 21.9154 12.9148 21.262 12.5482L18.226 10.8431L14.8081 14.2598L17.9074 17.358ZM4.47286 5.27512C4.40304 5.49003 4.36377 5.73003 4.36377 5.99294V22.0348C4.36377 22.4504 4.45541 22.8082 4.62122 23.0929L13.4543 14.2588L4.47286 5.27512ZM14.1318 14.9351L5.34777 23.7202C5.51577 23.7846 5.69686 23.8184 5.88777 23.8184C6.22813 23.8184 6.58268 23.718 6.94377 23.5173L17.0401 17.8479L14.1318 14.9351Z",
    fill: "#282B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/play store.62a7a95c379375541e12aa2fc207bba7.svg";
export { ForwardRef as ReactComponent };